module.exports = __webpack_public_path__ + "img/pic-logo-lj.a241d2b3.png";